import type { ReactNode } from 'react';
import { Badge } from '@/components/ui/badge';
import { twMerge } from 'tailwind-merge';

export const PRODUCT_BADGE_WRAPPER_BASE =
  'flex h-[20px] items-center gap-[3px] rounded-[100px] border border-solid border-text-tertiary-day bg-white py-[2px] pl-[2px]';

export const PRODUCT_BADGE_WRAPPER_CLASS = `${PRODUCT_BADGE_WRAPPER_BASE} pr-[4px]`;

export const PRODUCT_BADGE_TEXT_CLASS = 'text-text-primary text-[12px] leading-[14px] font-normal';

export const PRODUCT_BADGE_PROFIT_VALUE_CLASS =
  'inline-flex h-[16px] items-center rounded-[100px] bg-primary-green-day px-[6px] text-[12px] leading-[14px] font-medium text-white shrink-0';

type ProductBadgeOptions = {
  key: string;
  icon: ReactNode;
  text: ReactNode;
  wrapperClassName?: string;
};

export const renderProductBadge = ({ key, icon, text, wrapperClassName }: ProductBadgeOptions) => (
  <Badge key={key} variant='outline' className={twMerge(PRODUCT_BADGE_WRAPPER_CLASS, wrapperClassName)}>
    {icon}
    <span className={PRODUCT_BADGE_TEXT_CLASS}>{text}</span>
  </Badge>
);

export const renderProductProfitBadge = (discountPercent: number, suffix: ReactNode) => (
  <Badge key='profit' variant='outline' className={PRODUCT_BADGE_WRAPPER_CLASS}>
    <Badge variant='default' className={PRODUCT_BADGE_PROFIT_VALUE_CLASS}>
      {discountPercent}%
    </Badge>
    <span className={PRODUCT_BADGE_TEXT_CLASS}>{suffix}</span>
  </Badge>
);
